// charts/CombinedChart.jsx - Updated with Y-axis labels
import React from 'react';
import { ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { CustomTooltip, renderCustomizedLegend } from '../utils/chartUtils';

const CombinedChart = ({ chartData, timeRangeType }) => {
  const xAxisProps = {
    dataKey: "displayTime",
    angle: 0,
    textAnchor: timeRangeType === 'today' ? "end" : "end",
    height: 80,
    interval: "preserveStartEnd",
    tick: { fontSize: timeRangeType === 'today' ? 12 : 11 },
    tickFormatter: (value) => value || 'N/A'
  };

  return (
    <ResponsiveContainer width="100%" height={400}>
      <ComposedChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis {...xAxisProps} />
        
        {/* Left Y-axis for Heart Rate, Respiratory Rate, and HRV */}
        <YAxis 
          yAxisId="left" 
          orientation="left" 
          stroke="#dc3545"
          label={{ 
            value: 'Heart Rate / Respiratory Rate / HRV', 
            angle: -90, 
            position: 'insideLeft',
            style: { textAnchor: 'middle', fill: '#666' }
          }}
        />
        
        {/* Right Y-axis for Active Energy */}
        <YAxis 
          yAxisId="right" 
          orientation="right" 
          stroke="#ffc107"
          label={{ 
            value: 'Active Energy (kcal)', 
            angle: 90, 
            position: 'insideRight',
            style: { textAnchor: 'middle', fill: '#ffc107' }
          }}
        />
        
        <Tooltip content={<CustomTooltip />} />
        <Legend content={renderCustomizedLegend} />
        
        <Line
          yAxisId="left"
          type="monotone"
          dataKey="respiratory_rate"
          stroke="#17a2b8"
          strokeWidth={2}
          dot={{ r: timeRangeType === 'today' ? 4 : 3 }}
          activeDot={{ r: 8 }}
          name="Respiratory Rate"
          connectNulls={true}
        />
        
        <Line
          yAxisId="left"
          type="monotone"
          dataKey="heart_rate"
          stroke="#dc3545"
          strokeWidth={2}
          dot={{ r: timeRangeType === 'today' ? 4 : 3 }}
          activeDot={{ r: 8 }}
          name="Heart Rate"
          connectNulls={true}
        />
        
        <Bar
          yAxisId="right"
          dataKey="active_energy"
          fill="#ffc107"
          fillOpacity={0.7}
          barSize={timeRangeType === 'today' ? 30 : 20}
          name="Active Energy"
        />
        
        <Line
          yAxisId="left"
          type="monotone"
          dataKey="hrv"
          stroke="#28a745"
          strokeWidth={2}
          dot={{ r: timeRangeType === 'today' ? 4 : 3 }}
          activeDot={{ r: 8 }}
          name="HRV"
          connectNulls={true}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default CombinedChart;